module.exports = __webpack_public_path__ + "img/change.7e0419bd.svg";